import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatDividerModule} from "@angular/material/divider";
import {MatTooltipModule} from "@angular/material/tooltip";
import {UserRewardComponent} from "./..//user-reward/user-reward.component";
import {MatCardModule} from "@angular/material/card";
import {MatButtonModule} from "@angular/material/button";
import {MatPaginatorModule} from '@angular/material/paginator';
import {MasonryModule} from "@shared/partials/masonry/masonry.module";
import {CardOverlayModule} from "@pages/user/partials/card-overlay/card-overlay.module";
import {RouterModule} from "@angular/router";
import {
  RewardRedeemConfirmationDialogModule
} from "@app/feature/reward/reward-redeem-confirmation-dialog/reward-redeem-confirmation-dialog.module";
import {RewardCategoryFilterModule} from "@app/feature/reward/reward-category-filter/reward-category-filter.module";
import {RewardCardModule} from "@app/feature/reward/reward-card/reward-card.module";
import {UiLoaderModule} from "@app/feature/ui/ui-loader/ui-loader.module";

@NgModule({
  declarations: [ UserRewardComponent],
  exports: [ UserRewardComponent ],
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatDividerModule,
    MatTooltipModule,
    RewardRedeemConfirmationDialogModule,
    MatPaginatorModule,
    RewardCategoryFilterModule,
    MasonryModule,
    RewardCardModule,
    CardOverlayModule,
    RouterModule,
    UiLoaderModule
  ]
})
export class UserRewardModule { }
